module.exports = __webpack_public_path__ + "img/idc_datacenter_pic01.478a9aa9.jpg";